// NOTE: Do not use Emotion in here - react-day-picker will not notice it!
import * as React from 'react';
import { spacing } from '@metro-ui/tokens';
import { SelectNative, SelectOption } from '../../Select';
import { Layout } from '../../Layout';
import { AmountPicker } from '../../AmountPicker';
import { Separator } from '../../Separator';
import { Invisible } from '../../utils/visuallyHidden';
/**
 * A form for selecting year and month in a DatePicker. Exists once
 * per displayed month. To find out which YearMonthForm you are in,
 * you can only use the `date` prop.
 */
export var YearMonthForm = function (_a) {
    var id = _a.id, date = _a.date, localeUtils = _a.localeUtils, onChange = _a.onChange, monthLabel = _a.monthLabel, yearLabel = _a.yearLabel, _b = _a.months, months = _b === void 0 ? localeUtils.getMonths() : _b;
    var _c = React.useState(false), hasError = _c[0], setError = _c[1];
    var handleChange = function (newMonth, newYear) {
        if (!newYear)
            return;
        var shouldHaveError = newYear < 1000;
        setError(shouldHaveError);
        if (shouldHaveError)
            return;
        var monthOffset = (newYear - date.getFullYear()) * 12 + newMonth - date.getMonth();
        onChange(monthOffset);
    };
    var monthPickerId = id + "-month-" + date.getTime();
    var yearPickerId = id + "-year-" + date.getTime();
    return (React.createElement("form", { className: "DayPicker-Caption" },
        React.createElement("div", { className: "DayPicker-Caption-Items", style: {
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
            } },
            React.createElement(Layout, { grow: 1, basis: "0", justify: "center" },
                React.createElement("div", null,
                    React.createElement(Invisible, null,
                        React.createElement("label", { htmlFor: monthPickerId }, monthLabel)),
                    React.createElement(SelectNative, { isReduced: true, id: monthPickerId, name: "month", onChange: function (_event, newValue) {
                            return handleChange(Number(newValue), date.getFullYear());
                        }, value: "" + date.getMonth() }, months.map(function (month, i) { return (React.createElement(SelectOption, { key: month, value: "" + i }, month)); })))),
            React.createElement(Separator, { isVertical: true, style: { height: spacing.large } }),
            React.createElement(Layout, { grow: 1, basis: "0", justify: "center" },
                React.createElement(Layout, { style: { width: '6.5rem' } },
                    React.createElement(Invisible, null,
                        React.createElement("label", { htmlFor: yearPickerId }, yearLabel)),
                    React.createElement(AmountPicker, { id: yearPickerId, className: "mds-date-picker-year", name: "year", onChange: function (newValue) { return handleChange(date.getMonth(), newValue); }, hasError: hasError, value: date.getFullYear(), isReduced: true })))),
        React.createElement(Separator, { style: { margin: 0 } })));
};
//# sourceMappingURL=YearMonthForm.js.map